<template>
  <router-link
    :to="{ name: 'kohde', params: { example_id: data.slug } }"
    tag="div"
    class="item card">
    <!-- style="visibility:hidden;"> -->

    <div class="content">

      <!-- kuva -->
      <div class="gallery-card-image">
        <img v-if="data.mainImg_thumbM" :src="data.mainImg_thumbM">
        <img v-else-if="data.mainImg" :src="data.mainImg">
        <!-- <img :src="data.mainImg" @load="resizeGridItem"> -->
      </div>

      <!-- tiedot -->
      <div class="gallery-card-info">
          <h4>{{ data.title }}</h4>
          <span class="sub block font-9 lheight-12">{{ data.locCountry }}, {{ data.locCity }} {{ data.year }}</span>
      </div>

      <!-- teksti -->
      <div v-html="data.teaser" class="gallery-card-text text-content-html my-3" style="font-size: 0.85rem;"></div>

      <!-- keinolista -->
      <div class="gallery-card-means mb-1">
        <p class="txt-bold">Ketteryyden resepti:</p>
        <!-- <p>{{this.listOfMeans}}</p> -->
        <ul>
          <li v-for="(mean, index) in listOfMeans" :key="index" class="flex align-center mb-1">
            <div :class="setClass(mean.ref)" class="rounded-full flex-shrink-0 mr-1" style="width: 0.7rem; height: 0.7rem;"></div>
            <span class="lheight-8">{{ mean.title }}</span>
          </li>
        </ul>
      </div>

      <div class="h-1"></div> <!-- for visual reasons -->

    </div>

  </router-link>
</template>

<script>
export default {
  name: 'GitemExamples',

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      examples: []
    }
  },

  computed: {
    listOfMeans () {
      let usedData = this.data.addedMeans.map(a => a).map(aa => aa)
      let listOfUsedMeans = []
      usedData.forEach(mean => {
        listOfUsedMeans.push({
          title: mean.title,
          ref: mean.ref
        })
      })
      let arranged = listOfUsedMeans.slice()
      arranged.sort(this.compareValues('ref'))
      return arranged
    }
  },

  methods: {
    setClass (ref) {
      return {
        ['group-' + ref]: true
      }
    },

    // dynamic sorting function:
    compareValues (key, order = 'asc') {
      return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) { // property doesn't exist on either object
          return 0
        }

        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return (
          (order === 'desc') ? (comparison * -1) : comparison
        )
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";
</style>
